import { DSText } from '@engenharia/ds-react';
import styled from 'styled-components';
import spaces from '../../../styles/theme/spaces';
import colors from '../../../styles/theme/colors';
import { sizes } from '../../../styles/theme/devices';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: auto;

  header {
    position: sticky;
    top: 0;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spaces.small} ${spaces.small};
  background: linear-gradient(135deg, #ef9f2e 37.83%, #e02b4b 100%);
  box-sizing: border-box;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || '720px'};
  padding: 0;
  border-radius: 16px;
  background: ${colors.default.white};
  overflow: visible;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
`;

const BoxContent = styled.div`
  padding: ${spaces.small} ${spaces.xs} ${spaces.xs};
  overflow: visible;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${sizes.tablet}) {
    padding: 28px 28px 24px;
  }
`;

const Heading = styled(DSText)`
  color: ${colors.gray[800]};
  font-weight: 600;
  text-align: center;
  font-size: 18px;
  margin-bottom: ${spaces.xs};
  width: 100%;
  line-height: 1.35;

  @media (min-width: ${sizes.tablet}) {
    font-size: 20px;
    line-height: 1.4;
  }
`;

export { Box, BoxContent, Container, Content, Heading };
